import { render, staticRenderFns } from "./LeadDetailsView.vue?vue&type=template&id=4f3cc54c&"
import script from "./LeadDetailsView.vue?vue&type=script&lang=js&"
export * from "./LeadDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./LeadDetailsView.vue?vue&type=style&index=0&id=4f3cc54c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports